import script from "./recent-records-popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./recent-records-popover.vue?vue&type=script&setup=true&lang=ts"

import "./recent-records-popover.vue?vue&type=style&index=0&id=22eba374&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22eba374"]])

export default __exports__